import useDefinedContext from "hooks/useDefinedContext";
import { SidebarActionsContext } from "../SidebarProvider";

interface UseSidebarProps {}

function useSidebarActions(props?: UseSidebarProps) {
  return useDefinedContext(SidebarActionsContext);
}

export default useSidebarActions;
